<div class="page-container">
    <div class="flex-container">
        <div class="app-grid">
            <div class="columns-11 header">
                <app-header
                    class="title"
                    [back]="true"
                    title="{{ 'archived-notifications.archivedNotifications' | translate }}"
                >
                </app-header>
                <span
                    *ngIf="totalNumberOfUnreadArchivedNotifications > 0"
                    class="margin-left-2 padding-left-2 padding-right-2 counter margin-top-6 margin-bottom-4"
                >
                    {{
                        totalNumberOfUnreadArchivedNotifications > 99 ? '99+' : totalNumberOfUnreadArchivedNotifications
                    }}
                </span>
            </div>
            <div class="columns-1" style="text-align: right">
                <!-- Tab Menu-->
                <ui-button [matMenu]="meatball" class="meatball tab-menu padding-top-6" size="no-padding">
                    <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                </ui-button>
                <mat-menu #meatball xPosition="before">
                    <button (click)="onMarkAllAsRead()" mat-menu-item>
                        {{ 'archived-notifications.markAllAsRead' | translate }}
                    </button>
                    <button (click)="onMoveAllToInbox()" mat-menu-item>
                        {{ 'archived-notifications.moveAllToInbox' | translate }}
                    </button>
                </mat-menu>
            </div>
        </div>
        <ui-card
            class="notification-view-container"
            [class.loading]="notificationService.isLoading$ | async"
            [withSpacing]="false"
            style="width: 100%"
        >
            <app-archived-notification-viewer
                (notificationsUpdated)="getUnreadArchivedNotificationsCount()"
                #archivedNotificationViewer
            ></app-archived-notification-viewer>
        </ui-card>
    </div>
</div>
